import React from "react";

import { FormLabel } from "@mui/material";

const Label = ({ required, label, fontSize, marginRight }) => {
  return (
    <FormLabel
      required={required}
      sx={{
        "& .MuiFormLabel-asterisk": { color: "#FF0000" },
        // width: "100%",
        color: "#37373A",
        fontSize: fontSize || "15px",
        fontWeight: "400px",
        lineHeight: "20px",
        wordWrap: "break-word",
        marginRight: marginRight,
      }}
      component="legend"
    >
      {label}
    </FormLabel>
  );
};

export default Label;
